
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event]/acts/[slug]",
      function () {
        return require("private-next-pages/[event]/acts/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event]/acts/[slug]"])
      });
    }
  